import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES,
    MARK_MESSAGES_AS_READ,
    UPDATE_UNREAD_COUNT,
    FETCH_UNREAD_MESSAGES,
    FETCH_UNREAD_MESSAGES_SUCCESS
} from "../store/types";

const INITIAL_STATE = {
    messages: [],
    loading: false,
    unreadCounts: {}, // { bookingId: count }
    error: {
        flag: false,
        msg: null
    }
}

export const chatreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MESSAGES:
            return {
                ...state,
                loading: true
            };
        case FETCH_MESSAGES_SUCCESS:
            return {
                ...state,
                messages: action.payload,
                loading: false
            };
        case FETCH_MESSAGES_FAILED:
            return {
                ...state,
                messages:null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case SEND_MESSAGE:
            return state;
        case STOP_FETCH_MESSAGES:
            return INITIAL_STATE;
        case MARK_MESSAGES_AS_READ:
            return {
                ...state,
                unreadCounts: {
                    ...state.unreadCounts,
                    [action.payload]: 0
                }
            };
        case UPDATE_UNREAD_COUNT:
            return {
                ...state,
                unreadCounts: {
                    ...state.unreadCounts,
                    [action.payload.bookingId]: action.payload.count
                }
            };
        case FETCH_UNREAD_MESSAGES_SUCCESS:
            return {
                ...state,
                unreadCounts: action.payload
            };
        default:
            return state;
    }
};